import React from 'react';
import { map, size } from 'lodash';
// import FA from 'react-fontawesome';

import fontawesome from '@fortawesome/fontawesome'
import {FontAwesomeIcon as FA} from '@fortawesome/react-fontawesome';
import faBrands from '@fortawesome/fontawesome-free-brands'
// import faSolid from '@fortawesome/fontawesome-pro-solid'

const faAnalytics = { prefix: 'fas', iconName: 'analytics', icon: [576, 512, [], "f643", "M510.62 92.63C516.03 94.74 521.85 96 528 96c26.51 0 48-21.49 48-48S554.51 0 528 0s-48 21.49-48 48c0 2.43.37 4.76.71 7.09l-95.34 76.27c-5.4-2.11-11.23-3.37-17.38-3.37s-11.97 1.26-17.38 3.37L255.29 55.1c.35-2.33.71-4.67.71-7.1 0-26.51-21.49-48-48-48s-48 21.49-48 48c0 4.27.74 8.34 1.78 12.28l-101.5 101.5C56.34 160.74 52.27 160 48 160c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-4.27-.74-8.34-1.78-12.28l101.5-101.5C199.66 95.26 203.73 96 208 96c6.15 0 11.97-1.26 17.38-3.37l95.34 76.27c-.35 2.33-.71 4.67-.71 7.1 0 26.51 21.49 48 48 48s48-21.49 48-48c0-2.43-.37-4.76-.71-7.09l95.32-76.28zM400 320h-64c-8.84 0-16 7.16-16 16v160c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V336c0-8.84-7.16-16-16-16zm160-128h-64c-8.84 0-16 7.16-16 16v288c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V208c0-8.84-7.16-16-16-16zm-320 0h-64c-8.84 0-16 7.16-16 16v288c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V208c0-8.84-7.16-16-16-16zM80 352H16c-8.84 0-16 7.16-16 16v128c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V368c0-8.84-7.16-16-16-16z"] };

fontawesome.library.add(faBrands)

const getFaIcon = (platform) => {
  switch (platform){
    case 'facebook':
      return ['fab', 'facebook-f'];
    case 'adwords':
      return ['fab', 'google'];
    case 'pinterest':
      return ['fab', 'pinterest-p'];
    case 'linkedin':
      return ['fab', 'linkedin-in'];
    case 'snapchat':
      return ['fab', 'snapchat-ghost']
    case 'gtm':
      return faAnalytics;
    default:
      return ['fab', platform];
  }
}

export const PixelIcon = ({platform, platform_id, zIndex}) => {
  return (<FA icon={getFaIcon(platform)} className="fa-pixel" style={zIndex && {zIndex}} title={platform_id && `${platform}: ${platform_id}`} />)
};

const PixelsIcons = ({pixels}) => {
  const num = size(pixels)
  const iconsList = map(pixels, (pixel, idx) => (<PixelIcon {...pixel} key={idx} zIndex={num - idx} />))
  return <span className="pixels-wrap">{iconsList}</span>
};

export default PixelsIcons;


// WEBPACK FOOTER //
// ./src/components/PixelSets/pixelsIcons.js